<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon>
            <i class="fa-user-check fa-fw" :class="{'fas': active, 'far': !active}"></i>
        </template>
        <template v-slot:content>
            <div class="tile-title">{{user.first_name}} {{user.last_name}}</div>
            <div class="meta" v-if="user.certification_number"><i class="fas fa-id-badge fa-fw mr-2"></i>{{user.certification_number}}</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat" v-if="user.cert_count"><i class="far fa-certificate"></i>{{user.cert_count}}</span>
            </div>
        </template>
        <template v-slot:details>
            <div class="tile-details">
                <div class="data mt-1">
                    <data-row mini title="User ID">{{user.id}}</data-row>
                    <data-row mini title="Registration Date">{{user.created_at | moment('MMM Do, YYYY')}}</data-row>
                    <data-row mini title="WIAA ID">{{user.certification_number || 'Not Set'}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";

    export default {
        name: 'WiaaCertificationTile',
        components: {CardListItem, DataRow},
        props: {
            card: {
                required: true
            },
            user: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .tile-details {
        margin-top: 0.5rem;
    }

    .meta {
        font-size: 0.8rem;
        color: #666;
        margin-top: 2px;
    }

    .stats {
        .stat {
            display: inline-block;
            margin-right: 1rem;
            font-size: 0.85rem;
            color: #999;
            
            i {
                margin-right: 0.3rem;
            }
        }
    }
</style>